<template>
    <div class="createGuarantee fd-com-white-bg">
        <MyTitle theTitle="申请担保"/>
        <div class="fd-com-scroll">
            <van-cell-group>
                <p style="color: #ee0a24; font-size: 14px;padding-left: 16px;padding-top: 10px">请先选择法院</p>
                <!-- 选择法院 -->
                <van-field
                        v-model="formData.cFymc"
                        required
                        clearable
                        readonly
                        label="选择法院"
                        right-icon="arrow"
                        placeholder="请选择申请法院"
                        @click="selectCourt"
                ></van-field>
                <!-- 保全类型 -->
                <van-field
                        v-model="formData.cBqlxText"
                        required
                        readonly
                        label="保全类型"
                        right-icon="arrow"
                        placeholder="请选择保全类型"
                        @click="handlerPicker('showBQLX', true)"
                ></van-field>
                <!-- 保全类型弹窗 -->
                <van-popup v-model="showBQLX" position="bottom">
                    <van-picker
                            show-toolbar
                            :columns="columnsBqlx"
                            @cancel="handlerPicker('showBQLX', false)"
                            @confirm="onConfirmBQLX"
                    ></van-picker>
                </van-popup>
                <!-- 保全类别 -->
                <van-field
                        v-model="formData.cBqlb"
                        required
                        readonly
                        clickable
                        label="保全类别"
                        right-icon="arrow"
                        placeholder="请选择保全类别"
                        @click="handlerPicker('showPicker', true)"
                ></van-field>
                <!-- 保全类别弹窗 -->
                <van-popup v-model="showPicker" position="bottom">
                    <van-picker
                            show-toolbar
                            :columns="columnsBqlb"
                            :default-index="0"
                            @cancel="handlerPicker('showPicker', false)"
                            @confirm="onConfirm"
                    ></van-picker>
                </van-popup>
                <!-- 案件类型 -->
                <van-field
                        v-model="formData.nAjlx"
                        v-if="formData_1.cBqlb == 2"
                        required
                        readonly
                        label="案件类型"
                        right-icon="arrow"
                        placeholder="请选择案件类型"
                        @click="handlerPicker('showPickerAjlx', true)"
                ></van-field>
                <!-- 案件类型弹窗 -->
                <van-popup v-model="showPickerAjlx" position="bottom">
                    <van-picker
                            show-toolbar
                            :columns="columnsAjlx"
                            :default-index="0"
                            @cancel="handlerPicker('showPickerAjlx', false)"
                            @confirm="onConfirmAjlx"
                    ></van-picker>
                </van-popup>
                <!-- 案号 -->
                <div class="fd-com-section" v-if="formData_1.cBqlb == 2">
                    <div class="fd-com-title">
                        案号
                        <span class="fd-com-case">例：（2019）京01民初10号</span>
                    </div>
                    <van-field
                            v-model="formData_1.cAhNf"
                            required
                            readonly
                            label="年份"
                            right-icon="arrow"
                            placeholder="请选择年份"
                            @click="handlerPicker('showAhNf', true)"

                    ></van-field>
                    <van-popup v-model="showAhNf" position="bottom">
                        <van-picker
                                show-toolbar
                                :columns="timeList"
                                :default-index="0"
                                @cancel="handlerPicker('showAhNf', false)"
                                @confirm="onConfirmAhNf"
                        ></van-picker>
                    </van-popup>
                    <van-field
                            v-model="formData_1.cAhFydz"
                            required
                            class="amount-ipt"
                            label="法院代字"
                            placeholder="请输入法院代字"
                    ></van-field>
                    <van-field
                            v-model="formData_1.cAhAjlxdz"
                            required
                            class="amount-ipt"
                            label="案件类型代字"
                            placeholder="请输入案件类型代字"
                    ></van-field>
                    <van-field
                            v-model="formData_1.cAhAjxh"
                            required
                            class="amount-ipt"
                            label="案件序号"
                            placeholder="请输入案件序号"
                    ></van-field>
                </div>
                <!-- 案由 -->
                <van-field
                        v-show="formData_1.cBqlb == 2 && isSelctlx"
                        v-model="formData.cAy"
                        required
                        clearable
                        readonly
                        label="案由"
                        right-icon="arrow"
                        placeholder="请选择案由"
                        @click="selectAy"
                ></van-field>
                <!--<van-field
                        v-show="formData_1.cBqlb == 2 && formData_1.nAjlx"
                        v-model="formData_1.cAy"
                        required
                        clearable
                        readonly
                        :label="ayLabelName"
                        right-icon="arrow"
                        :placeholder="'请选择'+ayLabelName"
                        @click="selectAy"
                ></van-field>
                 <van-field
                        v-show="formData_1.cBqlb == 2 && formData_1.nAjlx == 6"
                        v-model="formData_1.cAyxzxwName"
                        required
                        clearable
                        readonly
                        label="案由(行为种类)"
                        right-icon="arrow"
                        placeholder="请选择行为种类"
                        @click="selectAyXW"
                ></van-field>-->
                <van-field
                        v-show="formData_1.cBqlb == 2 && isSelctXZ"
                        v-model="formData_1.cAyName"
                        required
                        clearable
                        readonly
                        :label="ayLabel_1"
                        right-icon="arrow"
                        :placeholder="'请选择'+ayLabel_1"
                        @click="selectAyZT"
                ></van-field>
                <van-field
                        v-show="formData_1.cBqlb == 2 && isSelctXZ"
                        v-model="formData_1.cAyxzxwName"
                        required
                        clearable
                        readonly
                        :label="ayLabel_2"
                        right-icon="arrow"
                        :placeholder="'请选择'+ayLabel_2"
                        @click="selectAyXW"
                ></van-field>
                <van-field
                        v-show="formData_1.cBqlb == 2 && isSelctXZ && formData_1.cAhNf >= 2021"
                        v-model="formData_1.cXzaymc"
                        required
                        class="amount-ipt"
                        label="行政案由名称"
                        placeholder="请输入行政案由名称"
                ></van-field>

                <van-field
                        v-if="formData_1.cBqlb == 1"
                        v-model="formData.cFsqj"
                        required
                        readonly
                        label="非诉期间"
                        right-icon="arrow"
                        placeholder="请选择非诉期间"
                        @click="handlerPicker('showPickerFsqj', true)"

                ></van-field>
                <van-field
                        v-model="formData.cBxgs"
                        required
                        readonly
                        label="选择担保机构"
                        right-icon="arrow"
                        placeholder="请选择担保机构"
                        @click="handlerPicker('showPickerBxgs', true)"
                ></van-field>
                <van-popup v-model="showPickerBxgs" position="bottom">
                    <van-picker
                            show-toolbar
                            :columns="columnsBxgs"
                            :default-index="0"
                            @cancel="handlerPicker('showPickerBxgs', false)"
                            @confirm="onConfirmBxgs"
                    ></van-picker>
                </van-popup>
                <van-popup v-model="showPickerFsqj" position="bottom">
                    <van-picker
                            show-toolbar
                            :columns="codeList_fsqj"
                            :default-index="0"
                            @cancel="handlerPicker('showPickerFsqj', false)"
                            @confirm="onConfirmFsqj"
                    ></van-picker>
                </van-popup>
                <van-field
                        v-model="formData_1.nSqbqje"
                        required
                        class="amount-ipt"
                        label="申请保全金额(元)"
                        placeholder="请输入申请保全金额"
                        :disabled="!formData.cFymc"
                        @input="getPremium"
                ></van-field>
                <van-field
                        v-model="formData_1.nSqdbje"
                        required
                        readonly
                        class="amount-ipt"
                        label="申请担保金额(元)"
                        placeholder="请输入申请担保金额"
                ></van-field>
                <van-field
                        v-model="formData.cTjrlx"
                        required
                        readonly
                        label="提交人身份"
                        right-icon="arrow"
                        placeholder="请选择提交人身份"
                        @click="handlerPicker('showPickeSQR', true)"
                ></van-field>
                <van-popup v-model="showPickeSQR" position="bottom">
                    <van-picker
                            show-toolbar
                            :columns="columnsSQR"
                            :default-index="0"
                            @cancel="handlerPicker('showPickeSQR', false)"
                            @confirm="onConfirmSQR"
                    ></van-picker>
                </van-popup>
                <van-field
                    v-model="formData_1.cClerkNo"
                    class="amount-ipt"
                    label="咨询员编号"
                    placeholder="请输入咨询员编号"
                ></van-field>

            </van-cell-group>
            <!--保险公司和保费填写后,查询显示建议担保费和费率-->
            <div v-if="message" class="advice-amount">
                <span>{{message}}</span>
            </div>
            <div v-else>
                <div v-if="formData_1.nSqbqje && formData.cBxgs" class="advice-amount">
                    <template v-if="jybqf != maxjybqf || fl != maxfl">
                        <span>{{bqfTxt}}担保费：<span>{{jybqf}}~{{maxjybqf}}</span>元</span>
                        <br/>
                        <span><span>费率:</span>{{fl * 1000}}‰~{{maxfl * 1000 }}‰</span>
                    </template>
                    <template v-else-if="jybqf == maxjybqf || fl == maxfl">
                        {{ bqfTxt }}担保费：{{ jybqf }}元
                        >
                        <br />
                        费率: {{ fl * 1000 }}‰
                    </template>
                </div>
               <!--
                <div v-if="formData_1.nSqbqje && formData.cBxgs && (jybqf != maxjybqf || fl != maxfl)" class="advice-amount">
                    <span>{{bqfTxt}}担保费：<span>{{jybqf}}~{{maxjybqf}}</span>元</span>
                    <br/>
                    <span><span>费率:</span>{{fl * 1000}}‰~{{maxfl * 1000 }}‰</span>
                </div>
                <div v-if="formData_1.nSqbqje && formData.cBxgs && (jybqf == maxjybqf || fl == maxfl)" class="advice-amount">
                    <span>{{bqfTxt}}担保费：<span>{{jybqf}}</span>元</span>
                    <br/>
                    <span><span>费率:</span>{{fl * 1000}}‰</span>
                </div>-->
            </div>
        </div>

        <div class="fd-com-btn-container">
            <van-button
                type="info"
                round
                @click="applyGuarantee">
                申请担保
            </van-button>
        </div>
    </div>
</template>

<script>
import { Toast, Notify } from "vant";
import MyTitle from "../../components/common/myTitle";
import { mapGetters } from "vuex";
import { columnsSQR } from "../../utils/option.js";
import validate from "@/utils/validator/validator";
import {
  xzfyRule,
  bqlbRule,
  bxgsRule,
  fsqjRule,
  SqbqjeRule,
  tjrsfRule,
  ajlxRule,
  AhRule,
  AyRule,
  ahNfRule,
  FydzRule,
  AjlxdzRule,
  AjxhRule,
  cAyNameRule,
  cAyxzxwNameRule,
  cXzaymcRule,
  ZxybhRule,
} from "@/utils/validator/rules";
import { typeBqlb, typeBqlx } from "../../filters/index";

export default {
  data() {
    return {
      show: false,
      formData: {
        nSqfy: "",
        cFsqj: "未起诉或提起仲裁前",
        cFymc: "", //法院名称
        nSqbqje: "", //申请保全金额
        cBqlx: "",
        cBqlxText: "", //保全类型
        cBqlb: "", //保全类别
        cAh: "", //案号如（2018）京01民初10号

        cAhNf: "", //案号年份
        cAhFydz: "", //案号法院代字
        cAhAjlxdz: "", //案号案件类型代字
        cAhAjxh: "", //案号序号

        nAjlx: "", //案件类型
        cAy: "", //案由
        cAycode: "", //案由
        cAyxzxw: "",
        cXzaymc: "",
        cBxgs: "", //保险公司
        cTjr: "", //提交人
        nDbfy: "", //担保费用
        cFl: "", //担保费率
        cTjrlx: "申请人", //提交人类型
        cClerkNo: "", //咨询员编号
      },
      formData_1: {
        cFyid: "", // 法院id
        nSqfy: "",
        cFsqj: "1",
        cFymc: "", //法院名称
        nSqbqje: "", //申请保全金额
        cBqlx: "",
        cBqlxText: "", //保全类型
        cBqlb: "", //保全类别
        cAh: "", //案号如（2018）京01民初10号

        cAhNf: "", //案号年份
        cAhFydz: "", //案号法院代字
        cAhAjlxdz: "", //案号案件类型代字
        cAhAjxh: "", //案号序号

        nAjlx: "", //案件类型
        cAy: "", //案由
        cAyxzxw: "",
        cXzaymc: "",
        cAycode: "", //案由
        cBxgs: "", //保险公司
        cTjr: "", //提交人
        nDbfy: "", //担保费用
        cFl: "", //担保费率
        cTjrlx: "1", //提交人类型
        cClerkNo: "", //咨询员编号
      },
      showAhNf: false, //案号年份
      isSelctlx: false, //控制案由的显示隐藏
      isSelctXZ: false, //控制案由（行政）的显示隐藏
      showPicker: false,
      showBQLX: false,
      showPickerAjlx: false,
      showPickerBxgs: false,
      showPickerFsqj: false,
      showPickeSQR: false,
      showPickerAY: false,
      columnsBxgs: [],
      columnsSQR: columnsSQR,
      qibubqf: 0, //起步价
      bqfTxt: "建议", //建议或最低
      jybqf: 0, // 最小保全费
      maxjybqf: 0, //最大保全费
      fl: 0, // 最小费率
      maxfl: 0, //最大费率
      powerKeys_cBqlb: "",
      powerKeys_cBqlx: "",
      powerKeys_cFysx: "",
      message: "",

      timeList: [], //年份列表
      ayLabel_1: "",
      ayLabel_2: "",
      // 案号代码（用于对接在线服务网）
      cAhdm: ''
    };
  },
  components: {
    MyTitle,
  },
  watch: {
    formData: {
      cFyid: "", // 法院id
      nSqfy: "",
      cFsqj: "",
      cFymc: "", //法院名称
      nSqbqje: "", //申请保全金额
      cBqlb: "诉前保全", //保全类别
      cAh: "", //案号如（2018）京01民初10号
      nAjlx: "", //案件类型
      cAy: "", //案由
      cAycode: "", //案由
      cBxgs: "", //保险公司
      cTjr: "", //提交人
      nDbfy: "", //担保费用
      cFl: "", //担保费率
      cTjrlx: "申请人", //提交人类型
      cAyxzxw: "", //案由代码值
      cAyName: "", //案由主体类型
      cAyxzxwName: "", //案由行为种类
      cXzaymc: "",
    },
    formData_1: {
      cFyid: "", // 法院id
      nSqfy: "",
      cFsqj: "",
      cFymc: "", //法院名称
      nSqbqje: "", //申请保全金额
      nSqdbje: "", //申请担保金额
      cBqlb: "1", //保全类别
      cAh: "", //案号如（2018）京01民初10号
      nAjlx: "", //案件类型
      cAy: "", //案由
      cBxgs: "", //保险公司
      cTjr: "", //提交人
      nDbfy: "", //担保费用
      cFl: "", //担保费率
      cTjrlx: "1", //提交人类型
      nMaxdbfy: "",
      cMaxfl: "",
      cAyxzxw: "", //案由代码值
      cAyName: "", //案由主体类型
      cAyxzxwName: "", //案由行为种类
      cXzaymc: "",
    },
    "formData.cFymc": function () {
      let cBqlb = this.powerKeys_cBqlb.split(",")[0];
      this.onConfirm({ text: typeBqlb(cBqlb), keyId: cBqlb });
      let cBqlx = this.powerKeys_cBqlx.split(",")[0];
      this.onConfirmBQLX({ text: typeBqlx(cBqlx), keyId: cBqlx });
    },
    "formData_1.cAhNf"(value, oldValue) {
      console.log(
        "----更改年份 watch 111",
        "varlue:" + value,
        "oldValue:" + oldValue
      );
      var nfKey_new = Number(value) >= 2021 ? 2 : 1;
      var nfKey_old = Number(oldValue) >= 2021 ? 2 : 1;
      if (!oldValue || (value && oldValue && nfKey_new !== nfKey_old)) {
        this.initAyLabel();
        this.initAyValue();
      }
    },
  },
  created() {
    this.sendFy();
    this.getBXGS();
    this.sendAy();
    this.initCodeType();
  },
  activated() {
    this.sendFy();
    this.sendAy();
  },
  computed: {
    ...mapGetters([
      "codeList_121000",
      "codeList_118000",
      "codeList_301000",
      "codeList_301110",
      "codeList_301210",
      "codeList_301510",
      "codeList_304000",
    ]),
    columnsBqlx() {
      return this.codeList_301000.filter(
        (item) => this.powerKeys_cBqlx.indexOf(item.keyId) > -1
      );
    },
    columnsBqlb() {
      return this.codeList_304000.filter(
        (item) => this.powerKeys_cBqlb.indexOf(item.keyId) > -1
      );
    },
    columnsAjlx() {
      return this.codeList_121000.filter((item) => item.keyId !== "12");
    },
    /*timeList() {
                let yearList = []
                let minYear = 2018
                let maxYear = new Date().getFullYear()
                for (let i = minYear; i <= maxYear; i++) {
                    yearList.unshift({
                        text: i,
                        keyId: i
                    })
                }
                return yearList
            },*/
    params() {
      let nSqbqje = Number(this.formData_1.nSqbqje);
      let nSqdbje = Number(this.formData_1.nSqdbje);

      if (this.formData_1.cBqlb === "1") {
        this.formData_1.cAy = "";
        this.formData_1.cAyName = "";
        this.formData_1.cAycode = "";
        this.formData_1.cAyxzxw = "";
        this.formData_1.cAyxzxwName = "";
        this.formData_1.nAjlx = "";
        this.formData_1.cAh = "";
        this.formData_1.cAhAjlxdz = "";
        this.formData_1.cAhAjxh = "";
        this.formData_1.cAhFydz = "";
        this.formData_1.cAhNf = "";
      }

      return {
        ...this.formData_1,
        nSqbqje,
        nSqdbje,
      };
    },
    codeList_fsqj() {
      switch (this.formData_1.cBqlx) {
        case "1":
          return this.codeList_301110;
          break;
        case "2":
          return this.codeList_301210;
          break;
        case "3":
          return this.codeList_301510;
          break;
        default:
          return [];
      }
    },
    ayLabelName() {
      return this.formData_1.nAjlx == 6 ? "案由(主体类型)" : "案由";
    },
  },
  methods: {
    /* 操作选择弹层 */
    handlerPicker(name, type) {
      /* 选择保全类型和保全类别需要先提示选择法院 */
      if (
        (name === "showBQLX" ||
          name === "showPicker" ||
          name === "showPickerBxgs") &&
        !this.formData.cFymc
      ) {
        Notify({ type: "danger", message: "请先选择法院" });
        return;
      }

      this[name] = type;
    },
    initCodeType() {
      this.$store.dispatch("GetCodeType", 121000);
      this.$store.dispatch("GetCodeType", 118000);
      this.$store.dispatch("GetCodeType", 301000);
      this.$store.dispatch("GetCodeType", 301110);
      this.$store.dispatch("GetCodeType", 301210);
      this.$store.dispatch("GetCodeType", 301510);
      this.$store.dispatch("GetCodeType", 304000);

      this.$axios.get("ssbq/api/nfs").then((res) => {
        console.log("--res 000", res);
        let yearList2 = res.data.map((item) =>
          Object({ text: Number(item), keyId: Number(item) })
        );
        console.log("--yearList2 000", yearList2);
        this.timeList = yearList2;
      });
    },
    /* 初始化权限字 */
    initPowerKeys() {
      let cBqlb = this.powerKeys_cBqlb;
      let cBqlx = this.powerKeys_cBqlx;
      this.powerKeys_cBqlb = sessionStorage.getItem("powerKeys_cBqlb") || "";
      this.powerKeys_cBqlx = sessionStorage.getItem("powerKeys_cBqlx") || "";
      this.powerKeys_cFysx = sessionStorage.getItem("powerKeys_cFysx") || "";

      /* 初始化保全类型和类别 */
      if (this.powerKeys_cBqlb && cBqlb !== this.powerKeys_cBqlb) {
        let cBqlb = this.powerKeys_cBqlb.split(",")[0];
        this.onConfirm({ text: typeBqlb(cBqlb), keyId: cBqlb });
      }
      if (this.powerKeys_cBqlx && cBqlx !== this.powerKeys_cBqlx) {
        let cBqlx = this.powerKeys_cBqlx.split(",")[0];
        this.onConfirmBQLX({ text: typeBqlx(cBqlx), keyId: cBqlx });
      }
    },
    //选择案号年份
    onConfirmAhNf(item) {
      this.formData_1.cAhNf = item.text;
      this.showAhNf = false;
    },
    //选择案由
    selectAy() {
      sessionStorage.removeItem("Aysz");
      sessionStorage.setItem("cAhNf", this.formData_1.cAhNf);
      this.$router.push({
        path: "/selectAy",
      });
    },
    //选择案由行为
    selectAyXW() {
      // this.formData_1.cAyxzxw = 2;
      sessionStorage.setItem("cAhNf", this.formData_1.cAhNf);
      sessionStorage.setItem("Aysz", this.formData_1.cAyxzxw);
      this.$router.push({
        path: "/selectAyXW",
      });
    },
    //选择案由主体
    selectAyZT() {
      // this.formData_1.cAyxzxw = 1;
      sessionStorage.setItem("cAhNf", this.formData_1.cAhNf);
      sessionStorage.setItem("Aysz", this.formData_1.cAyxzxw);
      this.$router.push({
        path: "/selectAy",
      });
    },
    //获取案由
    sendAy() {
      let selectay = sessionStorage.getItem("selectay");
      let selectayId = sessionStorage.getItem("selectayId");
      if (selectayId) {
        this.formData_1.cAycode = selectayId;
        this.formData.cAycode = selectayId;
      }
      if (selectay) {
        let AyInfo = JSON.parse(selectay);
        this.formData_1.cAy = AyInfo;
        this.formData.cAy = AyInfo;
        this.formData_1.cAyName = AyInfo;
        this.formData.cAyName = AyInfo;
      }

      //获取行为案由
      let Ayxw = sessionStorage.getItem("Ayxw");
      let AyxwId = sessionStorage.getItem("AyxwId");
      console.log("--sendAy 000", Ayxw);
      console.log("--sendAy 111", AyxwId);

      if (Ayxw) {
        let AyxwStr = JSON.parse(Ayxw).join(",");
        this.formData_1.cAyxzxwName = AyxwStr;
        this.formData.cAyxzxwName = AyxwStr;
        this.formData_1.cXzaymc = AyxwStr;
        this.formData.cXzaymc = AyxwStr;
      }

      if (AyxwId) {
        let AyxwIdstr = JSON.parse(AyxwId).join(",");
        this.formData_1.cAyxzxw = AyxwIdstr;
        this.formData.cAyxzxw = AyxwIdstr;
      }
      //this.$forceUpdate()
    },
    //选择保全类型
    onConfirmBQLX(item) {
      this.formData.cBqlxText = item.text;
      this.formData_1.cBqlx = item.keyId;
      this.showBQLX = false;
    },
    //获取保险公司的接口 （后端正在开发）
    getBXGS() {
      this.$axios.get("ssbq/api/xcx/commoncodepz").then((res) => {
        res.data &&
          res.data.map((item) => {
            let obj = {
              keyId: "",
              text: "",
            };
            obj.keyId = item.cCode;
            obj.text = item.cName;
            this.columnsBxgs.push(obj);
          });
      });
    },
    applyGuarantee() {
      this.formData_1.cFl = this.fl;
      this.formData_1.nDbfy = this.jybqf;
      this.formData_1.nMaxdbfy = this.maxjybqf;
      this.formData_1.cMaxfl = this.maxfl;
      const validated = this.validateFormData();
      validated.then(() => {
        let selectayId = sessionStorage.getItem("selectayId");
        let AyxwId = sessionStorage.getItem("AyxwId");
        if (selectayId) {
          this.formData_1.cAycode = JSON.parse(
            sessionStorage.getItem("selectayId")
          );
        }
        if (AyxwId) {
          this.formData_1.cAyxzxw = JSON.parse(AyxwId).join(",") + ",";
        }
        this.params.cAh = `（${this.params.cAhNf}）${
          this.params.cAhFydz + this.params.cAhAjlxdz + this.params.cAhAjxh
        }号`;
        /*if (this.params.cBqlx == 1) {
                        this.params.cAh = ''
                    }*/

        console.log("--提交 000", this.params.cBqlx, this.params.cAh);
        console.log("--提交 111", this.params);

        // 当前页面嵌入在了线服务网，并且选择了诉讼保全时，要调接口获取案号代码
        console.log('_____zxfwtoken：', localStorage.getItem('zxfwtoken'));
        console.log('_____cBqlb：', this.formData_1.cBqlb);
        if (localStorage.getItem('zxfwtoken') && this.formData_1.cBqlb === '2') {
            const params = {
                fydm: this.formData_1.nSqfy,
                ah: this.params.cAh,
                zxfwToken: localStorage.getItem('zxfwtoken')
            };
            this.$axios.get('ssbq/api/bqyzw/bqsq/ahdm', params).then((res) => {
                if (res.code === 200) {
                    this.cAhdm = res.data;
                    console.log('——————this.cAhdm：————————', this.cAhdm);
                    this.params.cAhdm = this.cAhdm;
                    this.create();
                } else {
                    const errorMessage = res.message ? res.message : '案号代码获取失败';
                    this.$notify(errorMessage);
                    this.params.cAhdm = '';
                    // this.create();
                }
            });
        } else {
            this.params.cAhdm = '';
            this.create();
        }
      });
    },
    // 把原来的创建保全接口调用提出来一个方法，里面代码没改
    create() {
        this.$axios.post('ssbq/api/ssdb/sqdbxx?ly=2', this.params).then((res) => {
            if (res.code === 200) {
                sessionStorage.setItem('currentDbid', JSON.stringify(res.data));
                this.$router.push('/guaranteeInfo');
                sessionStorage.removeItem('selectay');
                sessionStorage.removeItem('Ayxw');
            } else {
                this.$notify(res.message);
            }
        })
    },
    sendFy() {
      if (sessionStorage.getItem("fcheckedFy") !== this.formData.cFymc) {
        this.formData_1.cBqlx = "";
        this.formData.cBqlxText = "";
        this.formData_1.cBqlb = "";
        this.formData.cBqlbText = "";
      }
      this.formData.cFymc = sessionStorage.getItem("fcheckedFy");
      this.formData_1.cFymc = sessionStorage.getItem("fcheckedFy");
      this.formData.nSqfy = sessionStorage.getItem("fcheckedFyKey") || "";
      this.formData_1.nSqfy = sessionStorage.getItem("fcheckedFyKey") || "";
      this.formData_1.cFyid = sessionStorage.getItem("fcheckedFyKey") || "";
    },
    selectCourt() {
      this.$router.push({
        path: "/selectCourt",
      });
    },
    onConfirm(item) {
      this.formData.cBqlb = item.text;
      this.formData_1.cBqlb = item.keyId;
      this.showPicker = false;
    },
    initAyLabel() {
      let { cAhNf, nAjlx } = this.formData_1;
      var key = Number(cAhNf) >= 2021 ? 2021 : 2020;
      if (key === 2020) {
        this.ayLabel_1 = Number(nAjlx) === 6 ? "案由(主体类型)" : "案由";
        this.ayLabel_2 = "案由(行为种类)";
      } else {
        this.ayLabel_1 = Number(nAjlx) === 6 ? "行政主体类型" : "案由";
        this.ayLabel_2 = "行政案由";
      }
    },
    initAyValue() {
      /* 重置案由 */
      this.formData.cAy = "";
      this.formData.cAyxzxw = "";
      this.formData.cAyName = "";
      this.formData.cAyxzxwName = "";
      this.formData.cXzaymc = "";
      this.formData_1.cAy = "";
      this.formData_1.cAyxzxw = "";
      this.formData_1.cAyName = "";
      this.formData_1.cAyxzxwName = "";
      this.formData_1.cXzaymc = "";
      sessionStorage.setItem("selectay", "");
      sessionStorage.setItem("selectayId", "");
      sessionStorage.removeItem("Ayxw");
      sessionStorage.removeItem("AyxwId");
    },
    /* 选择案件类型 */
    onConfirmAjlx(item) {
      if (item.keyId == 1 || item.keyId == 2) {
        this.isSelctlx = true;
      } else {
        this.isSelctlx = false;
      }
      if (item.keyId == 6) {
        this.isSelctXZ = true;
      } else {
        this.isSelctXZ = false;
      }
      sessionStorage.setItem("nAjlx", item.keyId);
      this.formData.nAjlx = item.text;
      this.formData_1.nAjlx = item.keyId;
      this.showPickerAjlx = false;
      /* 重置案由 */
      this.formData_1.cAy = "";
      this.formData.cAy = "";
      this.formData_1.cAyxzxw = "";
      this.formData.cAyxzxw = "";
      this.formData_1.cAyName = "";
      this.formData.cAyName = "";
      this.formData_1.cAyxzxwName = "";
      this.formData.cAyxzxwName = "";

      this.initAyLabel();
      this.initAyValue();

      console.log("--onConfirmAjlx 000", this.formData.cBqlb, this.isSelctXZ);
    },
    onConfirmBxgs(item) {
      this.formData.cBxgs = item.text;
      this.formData_1.cBxgs = item.keyId;
      window.sessionStorage.setItem("isRB", item.keyId);
      // window.sessionStorage.setItem('Bxgs',item.text)
      this.showPickerBxgs = false;
      if (item.keyId === "001") {
        Toast("您选择的保险公司需要提供被申请人的证件信息。");
      }
      this.getPremium();
    },
    onConfirmFsqj(item) {
      this.formData.cFsqj = item.text;
      this.formData_1.cFsqj = item.keyId;
      this.showPickerFsqj = false;
    },
    onConfirmSQR(item) {
      this.formData.cTjrlx = item.text;
      this.formData_1.cTjrlx = item.keyId;
      this.showPickeSQR = false;
    },
    validateFormData: function () {
      let descriptor = {
        nSqfy: xzfyRule,
        cBqlb: bqlbRule,
      };
      if (this.formData_1.cBqlb == 2) {
        // 诉讼保全
        descriptor.nAjlx = ajlxRule;
        // descriptor.cAh = new AhRule(true);
        descriptor.cAhNf = ahNfRule;
        descriptor.cAhFydz = new FydzRule(true, this.formData_1.cFyid);
        descriptor.cAhAjlxdz = new AjlxdzRule(true);
        descriptor.cAhAjxh = new AjxhRule(true);
        if (this.isSelctlx) {
          descriptor.cAy = AyRule(true);
        } else {
          descriptor.cAyName = cAyNameRule(true, this.ayLabel_1);
          descriptor.cAyxzxwName = cAyxzxwNameRule(true, this.ayLabel_2);
          console.log(
            "--validateFormData 000",
            this.formData_1.cAhNf,
            this.formData.cXzaymc,
            this.formData_1.cXzaymc
          );
          if (this.formData_1.cAhNf >= 2021) {
            descriptor.cXzaymc = cXzaymcRule(true);
          }
        }
      } else {
        // 诉前保全
        descriptor.cFsqj = fsqjRule;
      }
      descriptor.cBxgs = bxgsRule;
      descriptor.nSqbqje = new SqbqjeRule(true);
      descriptor.cTjrlx = tjrsfRule;
      descriptor.cClerkNo = new ZxybhRule(false);
      const validated = validate(descriptor, this.formData_1);
      return validated;
    },
    // 查询建议担保费和费率
    getPremium: function () {
      let bxgs = this.formData_1.cBxgs;
      let bxje = this.formData_1.nSqbqje;
      this.formData_1.nSqdbje = bxje;
      if (!bxgs || !bxje) {
        return;
      }
      let fyID = sessionStorage.getItem("fcheckedFyKey");
      if (fyID) {
        this.$axios
          .post(
            "commonapi/api/policy/premium?preserveAmount=" +
              bxje +
              "&institution=" +
              bxgs +
              "&corpId=" +
              fyID
          )
          .then((res) => {
            let data = res.data;
            if (data) {
              this.message = "";
              this.qibubqf = data.minPremium; //建议或最低
              this.jybqf = data.minAmount; //最小担保费
              this.maxjybqf = data.maxAmount; //最大担保费
              this.fl = data.minRate; //最小费率
              this.maxfl = data.maxRate; //最大费率
              console.log(
                "--getPremium 000",
                this.jybqf,
                this.qibubqf,
                Number(this.jybqf) > Number(this.qibubqf)
              );
              this.bqfTxt =
                Number(this.jybqf) > Number(this.qibubqf) ? "建议" : "最低";
            } else {
              this.message = res.message;
            }
          });
      } else {
        this.bqfTxt = "建议";
        Toast("请先选择法院！");
      }
    },
  },
  // beforeRouteEnter
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.initPowerKeys();
      if (from.name == "Index") {
        window.location.reload();
      }
      if (from.name == "selectCourt" && to.name == "createGuarantee") {
        let isRefresh = sessionStorage.getItem("isRefresh");
        if (isRefresh == "0") {
          sessionStorage.setItem("isRefresh", null);
          // window.location.reload();
        } else {
          sessionStorage.setItem("isRefresh", 0);
        }
      } else if (from.name == "createGuarantee" && to.name == "selectCourt") {
        sessionStorage.setItem("isRefresh", 0);
      }
    });
  },
  beforeRouteLeave(to, from, next) {
    if (
      to.name == "selectCourt" ||
      to.name == "selectAy" ||
      to.name == "selectAyXW"
    ) {
      from.meta.keepAlive = true;
    } else {
      from.meta.keepAlive = false;
      to.meta.keepAlive = false;
      // this.$destroy()
      next();
    }
    next();
  },
};
</script>

<style lang="less" scoped>
.createGuarantee {
  width: 100%;
  height: 100%;
  overflow: hidden;

  .advice-amount {
    margin-top: 10px;
    margin-bottom: 10px;
    text-align: right;

    > span {
      color: #fe4d67;
      font-size: 14px;
      margin-right: 30/2px;
    }
  }
}
</style>
